import { create } from "zustand";
import type { MappingEntryDto } from "./types";

/* The one zustand store in the console (plan Part B): unsaved row edits, keyed by
   ota, plus the server message for any row the last flush could not write. */

export interface MappingDraft {
  dirtyRows: Record<string, MappingEntryDto | null>;
  failures: Record<string, string>;
  setRow(ota: string, entry: MappingEntryDto | null): void;
  clearRow(ota: string): void;
  fail(ota: string, message: string): void;
  discard(): void;
  count(): number;
}

function without<T>(map: Record<string, T>, ota: string): Record<string, T> {
  const next = { ...map };
  delete next[ota];
  return next;
}

export const useMappingDraft = create<MappingDraft>((set, get) => ({
  dirtyRows: {},
  failures: {},
  setRow: (ota, entry) =>
    set((state) => ({
      dirtyRows: { ...state.dirtyRows, [ota]: entry },
      failures: without(state.failures, ota),
    })),
  clearRow: (ota) =>
    set((state) => ({ dirtyRows: without(state.dirtyRows, ota), failures: without(state.failures, ota) })),
  fail: (ota, message) => set((state) => ({ failures: { ...state.failures, [ota]: message } })),
  discard: () => set({ dirtyRows: {}, failures: {} }),
  count: () => Object.keys(get().dirtyRows).length,
}));
